import React from "react";
import { Container, Typography } from "@mui/material";
import MainNavigation from "@/components/MainNavigation/MainNavigation";

const Support = () => {
  return (
    <Container>
      <MainNavigation />
      <Container className="content-container">
        <Typography variant="h2">Need Asistance?</Typography>
        <Typography variant="h3">We are here to help!</Typography>
        <br />
        <p>
          <b>Email us:</b>
          <a href="mailto:support@edisoft.com"> support@edisoft.com</a>
        </p>
        <p>
          <b>Call us:</b> +1 416-299-0030
        </p>
        <p>
          <b>Toll Free:</b> +1 866-637-4268
        </p>
        <p>
          <b>Website:</b> <a href="https://www.edisoft.com/">www.shep.io</a>
        </p>
      </Container>
    </Container>
  );
};

export default Support;
